import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { delay } from "lodash";
import { SnapLineMode } from "mapbox-gl-draw-snap-mode";

import { removeGuides } from "./helper";

const { constants: Constants } = MapboxDraw;

const drawLineString: DrawCustomMode = {
  ...SnapLineMode,

  onSetup: function (opts) {
    const state = SnapLineMode.onSetup?.call(this, opts);
    state.midPoints = this._ctx.options.midPoints !== false; // default to true if not set
    removeGuides.call(this);

    return state;
  },

  onClick: function (state, e) {
    SnapLineMode.onClick?.call(this, state, e);

    // If midpoints are disabled, we want to exit the mode after drawing a line with 2 points (i.e. a single segment)
    if (!state.midPoints && state.line.coordinates.length === 3) {
      this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
    }
  },

  onMouseDown: function (state, e) {
    // Check for right-click (button 2) to complete the line
    if (e.originalEvent?.button === 2) {
      // Complete the line if it is in a valid state (at least 2 points)
      if (state.line.isValid()) {
        delay(() => {
          this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
        }, 0);
        return;
      }
    }

    // Call the parent mode's onMouseDown for normal left-click behavior
    SnapLineMode.onMouseDown?.call(this, state, e);
  },

  onStop: function (state) {
    SnapLineMode.onStop?.call(this, state);
  },
};

export default drawLineString;
